<script>
import UploadService from "../../../services/UploadService";
import {errors} from "browser-sync/dist/config";

export default {
    name: "AuditRows",
    props: {
        value: {
            required: true,
            type: Array,
        },
        title: {
            required: false,
            type: String,
            default: undefined,
        },
        addRowLabel: {
            required: false,
            type: String,
            default: "Add Row",
        },
        deleteRowLabel: {
            required: false,
            type: String,
            default: "Delete Row",
        },
    },
    data() {
        return {
            rows: [],
        }
    },
    computed: {
        errors() {
            return errors
        }
    },
    watch: {
        value: {
            handler(newValue) {
                this.rows = [...newValue];
            },
            immediate: true,
            deep: true,
        },
    },
    methods: {
        addRow() {
            if (!this.rows) {
                this.rows = [];
            }
            this.rows.push({});
            this.emitRows();
        },

        handleFileUpload($event, index) {
            let file = $event.target.files[0];
            UploadService.upload(file, 500).then(res => {
                this.rows[index].photo_url = res.data.full_url;
                this.$forceUpdate();
            });
            this.emitRows();
        },

        deletePhoto(index) {
            var confirm = window.confirm(
                "Are you sure you want to delete this photo?"
            );
            if (!confirm) {
                return;
            }
            this.rows[index].photo_url = null;
            // @todo delete file on disk
            this.$forceUpdate();
            this.emitRows();
        },

        deleteRow(index) {
            var confirm = window.confirm(
                "Are you sure you want to delete this row?"
            );
            if (!confirm) {
                return;
            }

            this.rows.splice(index, 1);
            this.$forceUpdate();
            this.emitRows();
        },
        emitRows() {
            this.$emit('input', this.rows);
        }
    },
}
</script>

<template>
    <div class="card">
        <div class="card-body">
            <div
                v-if="title"
                class="row"
            >
                <div class="col-sm-12">
                    <h3>{{ title }}</h3>
                </div>
            </div>
            <div class="report-rows">
                <div
                    class="report-row"
                    v-for="(row, index) in rows"
                    :key="index"
                >
                    <div class="report-row-photo">
                        <img
                            :src="row.photo_url"
                            v-if="row.photo_url"
                            class="report-row-img"
                        >

                        <div
                            class="report-row-no-photo"
                            v-if="!row.photo_url"
                        />

                        <div class="d-flex pr-1">
                            <label class="btn btn-info btn-upload">
                                <input
                                    type="file"
                                    id="file"
                                    accept="image/*"
                                    @change="handleFileUpload($event, index)"
                                >
                                Upload photo
                            </label>
                            <button
                                class="btn btn-danger"
                                v-if="row.photo_url"
                                @click.prevent="deletePhoto(index)"
                            >
                                Delete Photo
                            </button>
                        </div>
                        <error
                            :errors="errors"
                            :name="'rows.' + index + '.photo_url'"
                        />
                    </div>

                    <div class="report-row-text">
                        <textarea
                            name="report_row_text"
                            cols="30"
                            rows="10"
                            class="form-control"
                            placeholder="Write notes here..."
                            v-model="row.content"
                        />
                        <div class="text-right">
                            <button
                                class="btn btn-danger"
                                @click.prevent="deleteRow(index)"
                            >
                                {{ deleteRowLabel }}
                            </button>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-12 text-right">
                        <button
                            class="btn btn-info"
                            @click.prevent="addRow"
                        >
                            {{ addRowLabel }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
.report-row {
    display: flex;
    margin-bottom: 20px;
    padding: 5px;
    width: 100%;
    border-bottom: 1px solid grey;
    gap: 1rem;

    @media (max-width: 480px) {
        flex-direction: column;
    }

    &-photo {
        width: 200px;
        display: flex;
        flex-direction: column;

        .btn {
            width: 98%;
            margin: auto;
            margin-bottom: 5px;
        }
    }

    &-text {
        flex: 1;
    }

    &-no-photo {
        height: 200px;
        border: 1px dashed grey;
        margin: 2px;
    }

    &-img {
        max-width: 100%;
        max-height: 200px;
        margin: 2px auto;
    }
}

.btn-upload {
    input {
        width: 0;
        height: 0;
        position: absolute;
    }
}
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/parts/AuditRows.vue